import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IPromise} from "angular";
import {Møtevalideringsfeil, NyttMøteSkjemaModell} from "../../MøteTjeneste";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";
import moment from "moment";
import {MøteRessurs} from "../../../../../felles/tjenester/ressurser/MøteRessurs";

const css = require('./nyttMøteIOpprettPlanDialog.scss');

export class NyttMøteIOpprettPlanDialog {

    static visNyttMøteDialog(modell: NyttMøteSkjemaModell, visInkluderMalsakerValg: boolean, validerSpesifikasjon: (spesifikasjon: l.NyttMøteSpesifikasjon) => IPromise<Møtevalideringsfeil>, $mdDialog: angular.material.IDialogService): IPromise<NyttMøteIOpprettPlanDialogRespons> {
        return $mdDialog.show(this.dialogKonfigurasjon({nyttMoeteModell: modell, visInkluderMalsakerValg: visInkluderMalsakerValg, validerSpesifikasjon: validerSpesifikasjon}));
    }

    private static dialogKonfigurasjon(locals: Object): angular.material.IDialogOptions {
        return {
            template: require('./nyttMøteIOpprettPlanDialog.html'),
            controller: NyttMøteIOpprettPlanDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            locals: locals
        };
    }

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            NyttMøteIOpprettPlanDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    nyttMoeteModell: NyttMøteSkjemaModell; //settes via locals
    visInkluderMalsakerValg: boolean; //settes via locals
    validerSpesifikasjon: (spesifikasjon: l.NyttMøteSpesifikasjon) => IPromise<Møtevalideringsfeil>; //settes via locals

    alleTrinn = OpprettMøteTrinn;
    /** aktivt trinn, merk at dersom visInkluderMalsakerValg=false vil ikke trinn stemme overens med OpprettMøteTrinn enum
     * da 'Hvilke saker skal behandles i møtet?' trinnet vil være fjernet, og trinnene nummereres fortløpende fra 0 og oppover av md-tabs,
     * deltakere-trinnet får da nummer 1 og ikke 2 som OpprettMøteTrinn.deltakere har. */
    trinn: OpprettMøteTrinn = OpprettMøteTrinn.moetedetaljer;
    lagrer = false;

    nesteTrinn() {
        this.trinn++;
    }

    forrigeTrinn() {
        this.trinn--;
    }

    erPaaTrinn(trinn:OpprettMøteTrinn){
        return this.justertTrinnVerdi(trinn) == this.trinn;
    }

    erTrinnUtfoert(trinn:OpprettMøteTrinn){
        return this.justertTrinnVerdi(trinn) < this.trinn;
    }

    fjernMoete(){
        this.$mdDialog.hide({modell: this.nyttMoeteModell, fjernet: true});
    }

    lagre(skjema) {
        if (!skjema.$valid) return;
        this.nyttMoeteModell.standardStarttidspunkt = moment(this.nyttMoeteModell.moetedato.start).format('HH:mm');
        this.nyttMoeteModell.standardVarighet = MøteRessurs.møtevarighet({dato: this.nyttMoeteModell.moetedato});
        this.lagrer = true;
        this.$mdDialog.hide({modell: this.nyttMoeteModell, fjernet: false})
            .finally(() => this.lagrer = false);
    }

    avbryt() {
        this.$mdDialog.cancel();
    }

    //hjelpemetoder

    /** Justerer for differansen mellom md-tab trinn nummer og erTrinnUtfoert enum, ref kommentar på this.trinn */
    private justertTrinnVerdi(trinn:OpprettMøteTrinn){
        if (this.visInkluderMalsakerValg) return trinn;
        if (trinn == OpprettMøteTrinn.moetedetaljer) return OpprettMøteTrinn.moetedetaljer;
        return trinn -1;
    }
}

export interface NyttMøteIOpprettPlanDialogRespons{
    modell:NyttMøteSkjemaModell;
    fjernet:boolean;
}

enum OpprettMøteTrinn {
    moetedetaljer, saker, deltakere, publisering
}
